import React from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';
import { Modal, Button } from '../../canvasComponents/index';
import { clickSaveOnLeavingPageButton } from '../../hooks/useLeavingPageHandler';
// scss
import '../../css/components/PopUps/PopUps.scss';
// messages
import messages from './message';

function LeavingTooSoonPopUp(props) {
  const { isClaimAutoSaved, open, closeUserIsLeavingTooSoonPopUp, handleOnClickLeave, onClickCancel } = props || null;
  return (
    <Modal
      ariaHideApp={false}
      id="user_leaving_too_soon_popUp"
      isOpen={open}
      onRequestClose={() => { closeUserIsLeavingTooSoonPopUp(); onClickCancel(); }}
    >
      <div className="modal-grid-adj">
        <div className="pop-up-title">
          <p><FormattedMessage {...messages.header} /></p>
        </div>
        <div>
          <span className="pop-up-text-bigger">
            {isClaimAutoSaved ? <FormattedMessage {...messages.descriptionOne} /> : <FormattedMessage {...messages.descriptionTwo} />}
          </span>
          <br />
          <div className="several-buttons-wrapper">
            <Button
              id="leave-popup-button"
              primary
              className="pop-up-btn large-button"
              onClick={() => {
                clickSaveOnLeavingPageButton();
                handleOnClickLeave();
              }}
            >
              <FormattedMessage {...messages.leave} />
            </Button>
            <br />
            <Button className="black-underline-button" onClick={() => { closeUserIsLeavingTooSoonPopUp(); onClickCancel(); }}>
              <FormattedMessage {...messages.cancel} />
            </Button>
          </div>
        </div>
      </div>
    </Modal>
  );
}

export default injectIntl(LeavingTooSoonPopUp);
